/**
 * Wallet funding (FSD Part 3, TRS R023, V058, V064) — the register of wallet
 * funding requests, the decision on each, and the link to the transfer
 * instruction that carries the money. The wiring packet spreads
 * `TREASURY_WALLET_FUNDING_ROUTES` into the treasury routes and adds the nav
 * item `treasury-wallet-funding` in p03.
 *
 * Gated on `treasury.wallet.funding.read` — what `GET /wallet-replenishments`
 * declares. Deciding needs `treasury.wallet.replenish`, checked on the screen
 * and again by the server.
 *
 * This file imports nothing from `treasury/routes.ts`, which will spread it, so
 * the spread cannot become an import cycle.
 */

import type { RouteRecordRaw } from 'vue-router'

import { WALLET_FUNDING_PERMISSIONS } from '@/modules/treasury/wallet-funding/permissions'

export const TREASURY_WALLET_FUNDING_PATH = '/treasury/wallet-funding'

/** The register narrowed to one wallet — the link a wallet's own screen uses. */
export function walletFundingFor(walletId: number): string {
  return `${TREASURY_WALLET_FUNDING_PATH}?walletId=${walletId}`
}

export const TREASURY_WALLET_FUNDING_ROUTES: RouteRecordRaw[] = [
  {
    path: TREASURY_WALLET_FUNDING_PATH,
    name: 'treasury-wallet-funding',
    component: () => import('@/modules/treasury/wallet-funding/WalletFundingView.vue'),
    meta: {
      titleKey: 'treasury.routeTitles.walletFunding',
      permission: WALLET_FUNDING_PERMISSIONS.fundingRead,
    },
  },
]
